up.compiler('[check-all]', (element) => {
  let checkboxes = element.closest('form').querySelectorAll('input[type=checkbox]')
  let upValidate = element.closest('form').getAttribute('up-validate') !== null

  function init() {
    checkboxes.forEach((checkbox) => {
      up.on(checkbox, 'change', () => {
        if (!checkbox.checked && !upValidate) {
          element.removeAttribute('checked')
          element.querySelector('.icon-text').textContent = 'Alle auswählen'
        }
      })
    })

    up.on(element, 'click', () => {
      if (element.getAttribute('checked') === null) {
        checkboxes.forEach((checkbox) => {
          checkbox.checked = true
        })
        if (!upValidate) {
          element.setAttribute('checked', true)
          element.querySelector('.icon-text').textContent = 'Alle abwählen'
        }
      } else {
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false
          if (!upValidate) {
            up.emit(checkboxes[0], 'change')
            element.querySelector('.icon-text').textContent = 'Alle auswählen'
          }
        })
      }
      up.emit(checkboxes[0], 'change')
    })
  }

  init()
})
